import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["orderTypeSelect", "deliveryAddressField", "pickupStoreField"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const orderType = this.orderTypeSelectTarget.value
    
    if (orderType === "delivery") {
      this.deliveryAddressFieldTarget.classList.remove("hidden")
      this.pickupStoreFieldTarget.classList.add("hidden")
    } else if (orderType === "pickup") {
      this.deliveryAddressFieldTarget.classList.add("hidden")
      this.pickupStoreFieldTarget.classList.remove("hidden")
    }
  }
}